import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    DE_SKUS?: boolean;
    DE_SKUS_OVERRIDE?: boolean;
    INSIGHTS_CREATE_CUSTOM_DASHBOARD?: boolean;
  }
}

export default {
  featureFlags: {
    // S2CX-8892 Data Explorer SKUs - 14, 30, 90
    DE_SKUS: true,
    DE_SKUS_OVERRIDE: undefined,
    // S2CX-6440 Create Custom Dashboard - Insights
    INSIGHTS_CREATE_CUSTOM_DASHBOARD: undefined,
  },
} satisfies FeatureFlagConfig;
